import { signal } from "@preact/signals-react"

export const userManifestSignal = signal(null)
export const userManifestErrorSignal = signal(null)
export const userManifestLoadedSignal = signal(false)